export default __webpack_public_path__ + "static/media/coaching_module_preview.9dce76d5.png";